export default "__VITE_ASSET__0dab7dea__"